import { Component, Input, OnInit } from '@angular/core';
import { IDashboardMidwifePayload, IDashboardMidwifeResponse } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';
declare var $: any;
@Component({
  selector: 'app-write-intro',
  templateUrl: './write-intro.component.html',
  styleUrls: ['./write-intro.component.scss']
})
export class WriteIntroComponent implements OnInit {

  intro: string = '';
  @Input() dashboard: IDashboardMidwifePayload;

  constructor(public dashboardService: DashboardService) { }

  ngOnInit(): void {
  }

  addIntro(){
    let body = {
      midwifeId: this.dashboard.midwifeId,
      intro: this.intro
    }

    this.dashboardService.addIntro(body)
    .subscribe((res: IDashboardMidwifeResponse)=>{
      console.log("Intro Added !: ",res);
      $('#write-intro').modal('hide');
    },err=>{
      console.error(err);
    });
  }

  clearData(){
    this.intro = '';
  }

}
